export default __webpack_public_path__ + "static/media/SEC1780.34I-41238_-24600_0.275c273d.jpg";